var exports = {
  "qu": "ArtifactName__H6qmks",
  "FV": "Artifact__t7u2vs",
  "Y9": "Header__KGS5KR",
  "DZ": "Heading___0g7o6",
  "$R": "Sha__H9w9Vi",
  "ZH": "File__bBcR19",
  "ou": "FileHeader__zroGor",
  "oS": "FileIcon__DSfHvQ",
  "o3": "FileName__nIaguM",
  "pl": "FileBody__PyZcAn",
};

module.exports = exports;
